import { render, staticRenderFns } from "./ExcludedContentLabels.vue?vue&type=template&id=ccc68008&"
import script from "./ExcludedContentLabels.vue?vue&type=script&lang=js&"
export * from "./ExcludedContentLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports